import { Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { ReactHookForm } from "../../../../components/hook-form/react-hook-form.component";
import { LoadingIndicator } from "../../../../components/loading-indicator.component";
import FormInput from "../../../../components/hook-form/form-input.component";
import { useCallback, useState } from "react";
import { useReactHookForm } from "../../../../hooks/useReactHookForm";
import { useSaveData } from "../../../../hooks/useSaveData";
import { fileUploadApiKeyStore } from "../../../../api/file-upload-key-store";
import { FileUploaded } from "../../../../models/fileUpload";
import { useDropzone } from "react-dropzone";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { useAuthorize } from "../../../../hooks/use-authorize";

const styling = {
    dropZone: {
        padding: '50px',
        border: '0.1em dashed #99A3A4',
        backgroundColor: '#F2F3F4',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
        borderRadius: '4px',
    },
    dialogTitleStyle: { padding: '16px 24px 0' },
    contentPadding: { paddingTop: '30px' },
};

interface FileUploadComponent {
    fileData: any;
    unitID: any;
    onClosed: () => void;
}
export const FileUploadComponent = ({ fileData, unitID, onClosed }: FileUploadComponent) => {

    const [files, setFiles] = useState<any>();
    const form = useReactHookForm({ defaultValues: { ...fileData } });
    const { isLoading, mutateAsync } = useSaveData<FileUploaded>(
        fileData?.fileID ? fileUploadApiKeyStore.updateUploadFile() : fileUploadApiKeyStore.uploadFile(),
        () => fileUploadApiKeyStore.getFiles({ unitID: unitID }));

    const handleDrop = useCallback((acceptedFiles: any) => {
        setFiles(acceptedFiles[0]);
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop,
    });

    const submitHanlder = async (value: any) => {
        if (files || fileData) {
            const formData = new FormData();
            if (value?.fileID) formData.append('fileID', value?.fileID);
            formData.append('UploadedFile', files ?? '');
            formData.append('FileName', files ? files?.name : value?.fileName);
            formData.append('FileType', files ? files?.type : value?.fileType);
            formData.append('Description', value.description ?? '');
            formData.append('FileSection', 'project');
            formData.append('UnitID', unitID);
            await mutateAsync({ data: formData });
            onClosed();
        }
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth={'xl'}
            // onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
                {fileData?.fileID ? "UPDATE FILE" : "UPLOAD FILE"}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClosed}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 9,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <DialogContent dividers style={styling.contentPadding} className="popupDilog">
                <ReactHookForm formName="UNIT_FILE_UPLOAD_FORM" onSubmit={submitHanlder} formContextProps={form}>
                    <LoadingIndicator isLoading={isLoading} />
                    <Grid container spacing={2}>
                        <Grid item lg={7} sm={7} xl={7} xs={7}>
                            <div style={styling.dropZone} {...getRootProps()}>
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                    <p>Drop the files here ...</p>
                                ) : (
                                    <div>
                                        {files ? (
                                            <p>{`${files.name} are selected to upload`}</p>
                                        ) : (
                                            fileData?.fileID ?
                                                <p>{`${fileData?.fileName} are selected to upload`}</p> :
                                                <p>Drag and drop a file here, or click to select a file</p>
                                        )}
                                    </div>
                                )}
                            </div>
                        </Grid>
                        <Grid item lg={5} sm={5} xl={5} xs={5}>
                            <FormInput label="Description" name="description" multiline={true} size={4.5} autoFocus />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <div className="spaceBetween">
                                <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
                                    Cancel
                                </Button>
                                <Button type='submit' variant="contained" style={{ width: '130px' }} disabled={isReadOnlyPermission}>
                                    Save
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </ReactHookForm>
            </DialogContent>
        </Dialog>
    );
}